import { render } from "./refund.vue?vue&type=template&id=f27411d0&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"

import "./refund.vue?vue&type=style&index=0&id=f27411d0&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27411d0"],['__file',"src/views/order/products/refund.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f27411d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f27411d0', __exports__)) {
    console.log('reload')
    api.reload('f27411d0', __exports__)
  }
  
  module.hot.accept("./refund.vue?vue&type=template&id=f27411d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('f27411d0', render)
  })

}


export default __exports__